import '../hooks/filtres/Filter.css';
import { useContext, useState } from "react";
import { AppContext } from "../../Context";
import { Preloader } from "../Preloader";
import { FilterButton } from '../hooks/filtres/useTableFilters';

const TarefaList = () => {
  const {
    dto,
    dtoLength,
    editMode,
    cancelEdit,
    updateDto,
    deleteDto,
    lookup,
    getItemlookup,
    filterdto,
  } = useContext(AppContext);

  // Storing users new data when they editing their info.
  const [newData, setNewData] = useState({});

  const saveBtn = () => {
    updateDto(newData);
  };

  const updateNewData = (e, field) => {
    let responsavel = getItemlookup(newData.idresponsavel);
    setNewData({
      ...newData,
      [field]: e.target.value,
      responsavel: responsavel,
    });
  };

  const enableEdit = (idtarefa,nome,iniciadaem,estimativa,pconcluido,nota,idresponsavel,responsavel) => {
    setNewData({idtarefa,nome,iniciadaem,estimativa,pconcluido,nota,idresponsavel,responsavel});
    editMode(idtarefa);
  };

  const deleteConfirm = (idtarefa) => {
    if (window.confirm("Confirma a exclusão?")) {
      deleteDto(idtarefa);
    }
  };


  return !dtoLength ? (
    <p>{dtoLength === null ? <Preloader/> : "Favor, insira uma tarefa"}</p>
  ) : 
  (<><FilterButton/>
    <table className="highlight">
      <thead>
        <tr>
          <th>Tarefa</th>
          <th>Responsável</th>
          <th>Estimativa</th>
          <th>Executado</th>
          <th>Expectativa</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        {dto.filter((data) => {
          return (String)(data.nome).toUpperCase().includes((String)(filterdto).toUpperCase()) || (String)(data.responsavel).toUpperCase().includes((String)(filterdto).toUpperCase()) || data.estimativa.includes(filterdto) || data.pconcluido.includes(filterdto) || filterdto === undefined ? data : null
        })
        .map(({idtarefa,nome,iniciadaem,estimativa,pconcluido,nota,idresponsavel,responsavel,expectativa,mensagem, isEditing }) => {
          return isEditing === true ? (
            <tr key={idtarefa}>
              <td>
                <input
                  type="text"
                  defaultValue={nome}
                  onChange={(e) => updateNewData(e, "nome")}
                />
              </td>
              <td>
                <select id="_responsavel" className="browser-default"
                  onChange={(e) => updateNewData(e, "idresponsavel")}
                  required
                  defaultValue={idresponsavel}
                >
                  <option key={-1} value="-1" disabled selected>Selecione um responsável</option>
                  {lookup.map((lkp) => {
                    return <option key={lkp.idusuario} value={lkp.idusuario}>{lkp.nome}</option>
                  })}
                </select> 
              </td>
              <td>
                <input
                  type="text"
                  className="datepicker"
                  defaultValue={estimativa}
                  onChange={(e) => updateNewData(e, "estimativa")}
                />
              </td>
              <td>
                <input
                  type="number"
                  defaultValue={pconcluido}
                  min={-1}
                  max={100}
                  onChange={(e) => updateNewData(e, "pconcluido")}
                />
              </td>
              <td colSpan={2}>
                <a className="waves-effect waves-light btn green-btn" onClick={() => saveBtn()}>
                <i className="material-icons left">save</i>
                </a>
                <a
                  className="waves-effect waves-light btn default-btn"
                  onClick={() => cancelEdit(idtarefa)}
                >
                <i className="material-icons left">cancel</i>
                </a>
              </td>
            </tr>            
          ) : (
            <tr key={idtarefa}>
                <td className={(expectativa>pconcluido*1.00 ?"red-information":"")}>{nome}</td>
                <td className={(expectativa>pconcluido*1.00 ?"red-information":"")}>{responsavel}</td>
                <td className={(expectativa>pconcluido*1.00 ?"red-information":"")}>{estimativa}</td>
                <td className={(expectativa>pconcluido*1.00 ?"red-information":"")}>{pconcluido} %</td>
                <td className={(expectativa>pconcluido*1.00 ?"red-information":"")}>{expectativa} %</td>              
                <td>
                        <a
                        className="waves-effect waves-light btn default-btn"
                        onClick={() => enableEdit(idtarefa,nome,iniciadaem,estimativa,pconcluido,nota,idresponsavel,responsavel)}
                        >
                        <i className="material-icons left">edit</i>
                        </a>
                        <a
                        className="waves-effect waves-light btn red-btn"
                        onClick={() => deleteConfirm(idtarefa)}
                        >
                        <i className="material-icons left">delete</i>
                        </a>
                </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </>);
};

export default TarefaList;